import React from "react";
import { ListTable } from "../../Table/listTable/listTable";
import { luncPackagesTitles } from "../../../Constants/tableTitles/ListTableTitle/lunchPackages.titles";
import { useGetAllLunchPackages } from "../../../hooks/lunchPackages/lunchPackages.hooks";
import { transformLunchPackagesListTableData } from "../../../Services/transformer/transformLunchPackagesListTableData";

export const LunchPackagesLists = () => {
  const { isLoading: isLunchPackagesLunching, data: lunchPackages } =
    useGetAllLunchPackages();

  return (
    <div>
      <ListTable
        titles={luncPackagesTitles}
        data={lunchPackages}
        isDataLoading={isLunchPackagesLunching}
        transformFn={transformLunchPackagesListTableData}
      />
    </div>
  );
};
